// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/rda/da-ordinare?societaId&commessaId',
    requestBody: null,
    response: '{"success":true,"data":[{"chiave":"string","articoloId":"number|null","codice":"string|null","descrizione":"string","tipologia":"string|null","unitaMisura":"string|null","prezzoStandard":"number|null","fornitoreAbituale":{"id":"number","ragioneSociale":"string"},"totaleDaOrdinare":"number","sorgenti":[{"rigaRdaId":"number","rdaId":"number","rdaEtichetta":"string","ordine":{"id":"number","numero":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string"},"quantita":"number","ordinata":"number","residuo":"number","note":"string|null"}]}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi?societaId',
    requestBody: null,
    response: '{"sedi":[{"id":"number","nome":"string","societaId":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=FORNITORE&limit=500&societaId',
    requestBody: null,
    response: '{"data":[{"id":"number","ragioneSociale":"string|null","nome":"string|null","cognome":"string|null"}],"total":"number"}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini-fornitori/genera-composti',
    requestBody: '{"societaId":"number","ordini":[{"fornitoreId":"number","sedeId":"number","note":"string","righe":[{"rigaRdaId":"number","articoloId":"number","descrizione":"string","unitaMisura":"string","quantita":"number","prezzoUnitarioAtteso":"number"}]}]}',
    response: '{"success":true,"data":{"risultati":[{"esito":"CREATO|ERRORE","ordineFornitoreId":"number","fornitoreRagioneSociale":"string","nRighe":"number","motivo":"string"}],"creati":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
